import { render } from "./ClinicalTrialsView.vue?vue&type=template&id=c9d43430"
import script from "./ClinicalTrialsView.vue?vue&type=script&lang=js"
export * from "./ClinicalTrialsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__